// Имя стебля в составе букета для покупателя — одно правило для каталога, корзины и
// «Моих заказов»: короткое имя товара, а без него — полное без служебных пометок в
// скобках («Банка [composition]» — посуда и лом, «Эвкалипт [Букет]»). В заказе короткое
// имя — снимок на момент оформления (order_item_bouquet_components.product_short_name).
export function componentName(c) {
  const short = (c?.product_short_name || '').trim();
  if (short) return short;
  return String(c?.product_name || '').replace(/\s*\[[^\]]*\]/g, '').trim();
}
